"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WEBAPP_BASE_URL_STAGING = exports.WEBAPP_BASE_URL_PRODUCTION = void 0;
const WEBAPP_BASE_URL_PRODUCTION = 'https://embedded.cardless.com';
exports.WEBAPP_BASE_URL_PRODUCTION = WEBAPP_BASE_URL_PRODUCTION;
const WEBAPP_BASE_URL_STAGING = 'https://embedded.cardless-staging.com';
exports.WEBAPP_BASE_URL_STAGING = WEBAPP_BASE_URL_STAGING;
